<template>
    <div class="content-subheader-page">{{ text }}</div>
</template>
<script>
export default {
    name: 'ContentSubheaderPage',
    props: {
        text: String
    }
}
</script>